import { connect, useDispatch } from "react-redux";
import { IstudentFinanceAccountDetails } from "../../../../models/student/studentAccountsDetails";
import { useEffect } from "react";
import { setStudentFinancialAccountDetail } from "../../../../store/slices/student/studentFinancialAccountDetails";
import { getStudentFinancialAcoountDetails } from "../../../../action/student/studentAccountDetailsActionCreator";
import { getCurrentUserData } from "../../../../action/user/userProfileActionCreator";

const StudentAccountDetail = (props : IstudentFinanceAccountDetails) => {
  const { getStudentFinancialAccount, studentFinancialAccount, userInfo }= props; 

  const dispatch = useDispatch();

  useEffect(() => {
    if (userInfo && userInfo?.id) {
    getStudentFinancialAccount(userInfo?.id);
    }
  }, [userInfo?.id]);

  useEffect(() => {
    return () => {
      dispatch(setStudentFinancialAccountDetail([]));
    };
  }, []);

  return (
    <>
        <div className="title">
          <h2>Student Accounts</h2>
        </div>
        <div className="row snapshot-wrap">
          {studentFinancialAccount?.map((Details) => (
            <div className="col-lg-3">
            <div className="snapshot-card">
              <div className="icon">
                <img src={Details.image} alt="" />
              </div>
              <div className="desc">
                <h5>{Details.shortDescription === "Billable Credit Hours"
                    ? Details.amount < 10
                      ? `0${Details.amount}`
                      : Details.amount
                    : `$${Details.amount}`}</h5>
                <p>{Details.shortDescription}</p>
              </div>
            </div>
          </div>
          ))} 
        </div>
    </>
  );
};

const mapDispatchToProps = {
  getStudentFinancialAccount: (studentId: string) =>
    getStudentFinancialAcoountDetails(studentId),
};

function mapStateToProps(state: any) {
  return {
    studentFinancialAccount:
      state.studentFinancailAccountDetail.financeAccountDetail,
      userInfo: state.userDetails.userProfileData,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(StudentAccountDetail);
